<template>
  <div v-loading="loading" class="glyRemoveDwxx">
    <div class="_title">
      <p class="_title_info">删除入网单位及相关用户</p>
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="right"
      class="_jbxxForm"
      label-width="200px"
    >
      <el-form-item label="单位名称：" prop="dwmc">
        <el-input v-model="form.dwmc" />
      </el-form-item>
      <el-form-item label="统一社会信用代码：" prop="shtyxydm">
        <el-input v-model="form.shtyxydm" />
      </el-form-item>
      <el-form-item label="删除原因：" prop="type">
        <el-select v-model="form.type" clearable placeholder="请选择" style="width: 100%">
          <el-option label="需将仓储变成非仓储" value="1" />
          <el-option label="需将非仓储变成仓储" value="2" />
        </el-select>
      </el-form-item>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button type="primary" @click="submit"> 确 认 </el-button>
      </div>
      <div>
        <p  style="color:red;margin-left:95px;margin-top:80px">提示：仅支持删除入网单位业务类型错误，需要在"仓储 <==> 非仓储"转换的入网企业</p>
      </div>
    </el-form>
  </div>
</template>

<script>
import { removeDwxxByGly } from '@/assets/js/system.js'
import {changeStatusPut} from "@/assets/js/yjpz";
export default {
  name: 'GlyRemoveDwxx',
  data() {
    return {
      loading: false,
      form: {
        dwmc: '',
        shtyxydm: '',
        type: '',
      },
      localData: false,
      rules: {
        type: [
          {
            required: true,
            message: '必须选择删除原因',
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    reset() {
      this.form = { dwmc: '', shtyxydm: '',type:'' }
    },
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.form.shtyxydm && !this.form.dwmc) {
            this.$message.error('单位名称与统一信用代码必填一个')
            return
          }
          this.$confirm('确定删除该单位及用户吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true
            removeDwxxByGly(this.form)
              .then((e) => {
                this.loading = false
                if (e.status === 200) {
                  this.$message.success('删除成功!')
                }
              }).catch(()=>{
              this.loading = false
            })
          })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })


        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.glyRemoveDwxx {
  padding: 20px;
  background-color: white;
  margin: 10px;
  height: calc(100% - 20px);
  ._title {
    margin-top: 50px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._jbxxForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 100px auto 0px auto;
    width: 50%;

    .el-form-item {
      margin-right: 0;
      width: 100%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 50px auto 0px auto;
    width: 50%;
  }
}
.descriptions {
    width: 70%;
    margin: 0 auto;;
}
</style>
